import FormattedMessage from 'I18n/components/FormattedMessage';
import { NavMarker } from 'react-rhumb';
import Section from 'settings-ui-lib/components/Section';
import ReminderSettings from '../settings/ReminderSettings';
import TimestampSettings from '../settings/TimestampSettings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function TaskDefaultsSection() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "DEFAULTS_SETTINGS"
    }), /*#__PURE__*/_jsxs(Section, {
      "data-selenium-test": "task-defaults-section",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "CrmSettingsTaskReminders.defaults.sectionHeader"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "CrmSettingsTaskReminders.defaults.sectionSubCopy"
      }),
      children: [/*#__PURE__*/_jsx(TimestampSettings, {}), /*#__PURE__*/_jsx(ReminderSettings, {})]
    })]
  });
}